import React, { useState, useEffect } from 'react'
import VisualizacaoPadrao from '../../../../components/VisualizacaoPadrao'
import { useParams } from "react-router-dom";
import { visualizar } from '../../../../util/AcessoApi'
import { useLocation } from 'react-router-dom/cjs/react-router-dom';

const Visualizacao = (props) => {
    let { id } = useParams();
    const [dados, setDados] = useState()
    const location = useLocation()
    let pron_id = location?.state?.pron_id

    useEffect(() => {
        visualizar('/atendimento/prontuario', pron_id,
            obj => {
                setDados(obj.id ? {
                    id,
                    modulo: props.modulo,
                    titulo: 'Visualização Prontuário',
                    grupos: [
                        {
                            titulo: 'Dados Gerais',
                            colunas: [
                                { titulo: 'Código', descricao: obj.id, tamanho: 'col-lg-4' },
                                { titulo: 'Paciente', descricao: obj.paciente, tamanho: 'col-lg-4' },
                                { titulo: 'Prestador', descricao: obj.prestador, tamanho: 'col-lg-4' },
                                { titulo: 'Última Consulta', descricao: obj.ultima_consulta, tamanho: 'col-lg-4' },
                            ]
                        },
                        {
                            tipoGrupo: 'tabela',
                            titulo: 'Histórico',
                            thead:
                                <tr>
                                    <td className='coluna-1'>Código</td>
                                    <td className='coluna-2'>Data</td>
                                    <td className='coluna-8'>Resumo</td>
                                </tr>,
                            tbody: obj?.historico?.map(item =>
                                <tr>
                                    <td>{item.id || '--'}</td>
                                    <td>{item.data_registro || '--'}</td>
                                    <td><div dangerouslySetInnerHTML={{ __html: item.resumo || '--' }}></div></td>
                                </tr>)
                        }
                    ]
                } : { titulo: 'Visualização Prontuário' })
            })
    }, [id])

    return dados ? <VisualizacaoPadrao data={dados} {...props} /> : null
}

export default Visualizacao